import { Flex, Text } from "@fluentui/react-northstar";
import TextArea from "antd/lib/input/TextArea";
import React, { useEffect, useState } from "react";
import AnnotationSystem from "../AnnotationSystem";
import { useIntelligentGrading } from "../../../../../../context/useIntelligentGrading";

const VideoResponse = ({ video, isAnnotationMode }) => {
  const { annotations, setAnnotations } = useIntelligentGrading();

  const index = annotations.findIndex(
    (annotation) => annotation.id === video.id
  );

  const onAnnotationAdd = (annotation) => {
    let clonedAnnotations = [...annotations];
    if (index === -1) {
      clonedAnnotations.push({ id: video.id, annotations: [annotation] });
    } else {
      clonedAnnotations[index].annotations.push(annotation);
    }
    setAnnotations(clonedAnnotations);
  };

  const onAnnotationDelete = (id) => {
    let clonedAnnotations = [...annotations];
    clonedAnnotations[index].annotations = clonedAnnotations[
      index
    ].annotations.filter((annotation) => annotation.id !== id);
    setAnnotations(clonedAnnotations);
  };
  const onAnnotationEdit = (id, comment) => {
    let clonedAnnotations = [...annotations];
    clonedAnnotations[index].annotations = clonedAnnotations[
      index
    ].annotations.map((annotation) =>
      annotation.id === id ? { ...annotation, comment } : annotation
    );
    setAnnotations(clonedAnnotations);
  };

  return (
    <Flex column gap="gap.small">
      <div
        style={{
          background: "#fafbfc",
          borderRadius: 10,
          padding: 20,
          marginBottom: 18,
          border: "1px solid #f0f0f0",
        }}
      >
        <Flex column gap="gap.small">
          <Flex column gap="gap.small">
            <Text content="Video Content Analysis" weight="semibold" />

            <video
              src={video.info}
              controls
              style={{
                width: "100%",
                minHeight: 350,
                background: "#222",
                borderRadius: 8,
                marginBottom: 8,
              }}
            />
          </Flex>
          {/* <Flex column gap="gap.small">
            <Text content="AI Transcription:" weight="semibold" />
            <TextArea rows={4} readOnly />
          </Flex> */}
        </Flex>
        {/* <div style={{ color: "#444", fontSize: 15, marginTop: 4 }}>
          Duration: {video.duration}
        </div> */}
      </div>

      <Flex column gap="gap.small">
        <Text content="Video Content" weight="semibold" />
        <AnnotationSystem
          isAnnotationMode={isAnnotationMode}
          essayText={video.extractedText}
          annotations={annotations?.[index]?.annotations || []}
          onAnnotationAdd={onAnnotationAdd}
          onAnnotationDelete={onAnnotationDelete}
          onAnnotationEdit={onAnnotationEdit}
        />
      </Flex>
    </Flex>
  );
};

export default VideoResponse;
